const storageKey = 'cardreplay.referral-attribution.v1'
const attributionLifetimeMs = 30 * 24 * 60 * 60 * 1_000

type ReferralAttribution = Readonly<{
  code: string
  capturedAt: number
}>

function isValidCode(value: unknown): value is string {
  return typeof value === 'string' && /^[A-Za-z0-9_-]{3,32}$/.test(value)
}

function readAttribution(): ReferralAttribution | null {
  if (typeof window === 'undefined') return null
  try {
    const value = JSON.parse(
      window.localStorage.getItem(storageKey) ?? 'null',
    ) as Partial<ReferralAttribution> | null
    if (
      !isValidCode(value?.code) ||
      typeof value.capturedAt !== 'number' ||
      value.capturedAt + attributionLifetimeMs < Date.now()
    ) {
      window.localStorage.removeItem(storageKey)
      return null
    }
    return { code: value.code, capturedAt: value.capturedAt }
  } catch {
    return null
  }
}

export function captureReferralCode(value: string): string | null {
  if (typeof window === 'undefined') return null
  const code = value.trim().toUpperCase()
  if (!isValidCode(code)) return null

  try {
    window.localStorage.setItem(
      storageKey,
      JSON.stringify({ code, capturedAt: Date.now() }),
    )
  } catch {
    return null
  }
  return code
}

export function getReferralCode(): string | null {
  return readAttribution()?.code ?? null
}
